module.exports = "<div class=\"rest-api-dialog\">\n    <ctx-modal show-modal=\"$ctrl.showModal\"\n               action-buttons=\"$ctrl.actionButtons\"\n               modal-title=\"$ctrl.title\">\n        <div style=\"text-align: center\">\n            {{'main.restApiExplorer.message'|translate}}\n        </div>\n    </ctx-modal>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/azurebackup/views/mainApp/dialogs/restApiExplorer/restApiExplorer.template.html
// module id = 409
// module chunks = 0